const tab_sections = {
    overview: 'Panoramica',
    authentication: 'Autenticazione',
    authorization: 'Autorizzazione',
    users: 'Utenti',
    developer: 'Sviluppatore',
    tenant: 'Inquilino',
};
export default Object.freeze(tab_sections);
